import {extractFontSizeUnitFromString, getFontSize as extractFontSize} from '../common'
import {FONT_SIZE_CLASSES_RULES} from './constants'

const isFontInRange = (fontStyleEntryItem: string, minValue: number, maxValue?: number) => {
    const size = extractFontSize(fontStyleEntryItem)
    if (!size) return false
    if (size < minValue) return false
    return !(maxValue && size > maxValue)
}

export const getFontSize = (fontSizeString: string) => {
    const {targetFontSize, scaleProportionally} =
        FONT_SIZE_CLASSES_RULES.find(({minSourceFontSize, maxSourceFontSize}) =>
            isFontInRange(fontSizeString, minSourceFontSize, maxSourceFontSize)
        ) ?? {}

    return !!targetFontSize && !scaleProportionally
        ? {targetFontSize, unit: extractFontSizeUnitFromString(fontSizeString)}
        : {}
}
